import './App.css';
import React from 'react';
import { HelmetProvider } from "react-helmet-async";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import Home from "./components/Home/Home";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </div>
  );
}

export default App;
